import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CONTACT = {
  support_email: "support@residenceproof.com",
  legal_email: "legal@residenceproof.com",
  rights_email: "rights@residenceproof.com",
  phone: "",
  address: "",
};

let cache = null;
let pending = null;
const listeners = new Set();

export const refreshSiteContent = async () => {
  pending = api.get("/content").then(({ data }) => data).catch(() => ({ contact: DEFAULT_CONTACT, certifications: [], stats: [], problem_stats: [] }));
  cache = await pending;
  listeners.forEach((fn) => fn(cache));
  return cache;
};

export const useSiteContent = () => {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    listeners.add(setContent);
    if (!cache && !pending) {
      refreshSiteContent();
    } else if (pending && !cache) {
      pending.then(setContent);
    }
    return () => {
      listeners.delete(setContent);
    };
  }, []);
  return content || { contact: DEFAULT_CONTACT, certifications: [], stats: [], problem_stats: [], loading: true };
};
